import { PickupCorporateAddress } from "./PickupSchedule";

export class PickupScheduleTimeSlot {
  start = "";
  end = "";

  constructor(fields?: Partial<PickupScheduleTimeSlot>) {
    Object.assign(this, fields);
  }
}

export class PickupScheduleRegularDay {
  day = "";
  checked = true;
  times: PickupScheduleTimeSlot[] = [];

  constructor(fields?: Partial<PickupScheduleRegularDay>) {
    Object.assign(this, fields);
  }
}

export class PickupScheduleSpecialDate {
  date = "";
  times: PickupScheduleTimeSlot[] = [];

  constructor(fields?: Partial<PickupScheduleSpecialDate>) {
    Object.assign(this, fields);
  }
}

export class PickupCorporateScheduleConfig {
  scheduleId = 0;
  clientId = 0;
  clientName = "";
  estimateAdditionalKoli = "";
  estimateWeight = "";
  serviceCodes: string[] = [];
  regularEnabled = false;
  regularDays: PickupScheduleRegularDay[] = [];
  specialEnabled = false;
  specialDates: PickupScheduleSpecialDate[] = [];
  address = new PickupCorporateAddress();

  get isEdit(): boolean {
    return this.scheduleId > 0;
  }

  constructor(fields?: Partial<PickupCorporateScheduleConfig>) {
    Object.assign(this, fields);
  }
}
